import React, { useState } from 'react';
import axios from 'axios';

const TTS = () => {
  const [textInput, setTextInput] = useState('');
  const [selectedVoice, setSelectedVoice] = useState('alloy'); // Example default
  const [selectedModel, setSelectedModel] = useState('tts-1'); // Must provide a valid model
  const [speed, setSpeed] = useState(1.0); // Speed factor
  const [audioURL, setAudioURL] = useState(null);
  const [loading, setLoading] = useState(false);

  // Example list of voices (replace with your actual voices)
const voices = ['alloy', 'ash', 'coral', 'echo', 'fable', 'onyx','nova','sage','shimmer'];

  // Example list of TTS models from the docs
  const models = ['tts-1', 'tts-1-hd'];

  const handleTextChange = (e) => {
    setTextInput(e.target.value);
  };

  const handleVoiceChange = (e) => {
    setSelectedVoice(e.target.value);
  };

  const handleModelChange = (e) => {
    setSelectedModel(e.target.value);
  };

  const handleSpeedChange = (e) => {
    setSpeed(parseFloat(e.target.value));
  };

  const handleConvert = async () => {
    if (!textInput.trim()) return;
    setLoading(true);
    setAudioURL(null);

    try {
      // If you need to use the API key:
      const apiKey = "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";

      const response = await axios.post(
        'https://api.openai.com/v1/audio/speech',
        {
          model: selectedModel,          // Required
          input: textInput,              // The text
          voice: selectedVoice,          // The voice
          speed: speed,                  // Speed factor
          response_format: 'mp3',        // So we get mp3 back
        },
        {
          responseType: 'arraybuffer',   // Important for binary data
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${apiKey}`, 
          },
        }
      );

      // Convert the array buffer to a Blob
      const audioBlob = new Blob([response.data], { type: 'audio/mp3' });
      // Create a URL for the blob so we can use it in an <audio> tag
      const audioUrl = URL.createObjectURL(audioBlob);
      setAudioURL(audioUrl);
    } catch (error) {
      console.error('Error generating TTS audio:', error);
      alert('Failed to generate speech. Check console for details.');
    } finally {
      setLoading(false);
    }
  };

  // Function to download the audio
  const handleDownload = () => {
    if (!audioURL) return;
    const link = document.createElement('a');
    link.href = audioURL;
    link.download = 'speech.mp3';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
      <h1>Text-to-Speech Demo</h1>

      {/* Text Input */}
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="text-input">Enter Text:</label><br />
        <textarea
          id="text-input"
          rows="5"
          cols="50"
          value={textInput}
          onChange={handleTextChange}
          placeholder="Type your text here..."
        />
      </div>

      {/* Model Selection */}
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="model-select">Select Model:</label><br />
        <select id="model-select" value={selectedModel} onChange={handleModelChange}>
          {models.map((model) => (
            <option key={model} value={model}>
              {model}
            </option>
          ))}
        </select>
      </div>

      {/* Voice Selection */}
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="voice-select">Select Voice:</label><br />
        <select id="voice-select" value={selectedVoice} onChange={handleVoiceChange}>
          {voices.map((voice) => (
            <option key={voice} value={voice}>
              {voice}
            </option>
          ))}
        </select>
      </div>

      {/* Speed Slider */}
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="speed-slider">Speed: {speed.toFixed(1)}x</label><br />
        <input
          id="speed-slider"
          type="range"
          min="0.5"
          max="2.0"
          step="0.1"
          value={speed}
          onChange={handleSpeedChange}
        />
      </div>

      {/* Convert Button */}
      <button onClick={handleConvert} disabled={loading}>
        {loading ? 'Converting...' : 'Convert to Speech'}
      </button>

      {/* Audio Playback & Download */}
      {audioURL && (
        <div style={{ marginTop: '20px' }}>
          <audio controls src={audioURL} />
          <br />
          <button onClick={handleDownload}>Download MP3</button>
        </div>
      )}
    </div>
  );
};

export default TTS;
